import { Directive, ElementRef, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output } from '@angular/core'

@Directive({
  selector: '[scopeInfiniteScroll]',
})
export class ScopeInfiniteScrollDirective implements OnInit, OnDestroy {
  @Input() scrollRootSelector = '.main-container'
  @Output() scrolledDown = new EventEmitter<void>()

  private observer?: IntersectionObserver
  private sentinel?: HTMLElement
  private debounce = false

  constructor(
    private el: ElementRef<HTMLElement>,
    private zone: NgZone
  ) {}

  ngOnInit() {
    this.zone.runOutsideAngular(() => {
      const rootEl = document.querySelector(this.scrollRootSelector) as HTMLElement | null

      // add sentinel to the end of the deliverables-container
      this.sentinel = document.createElement('div')
      this.sentinel.className = 'io-sentinel'
      this.sentinel.style.cssText = 'width:100%;height:1px;pointer-events:none;opacity:0;'
      this.el.nativeElement.appendChild(this.sentinel)

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting && !this.debounce) {
              this.debounce = true
              this.zone.run(() => this.scrolledDown.emit())
              setTimeout(() => (this.debounce = false), 300)
            }
          }
        },
        {
          root: rootEl ?? null, // main container
          rootMargin: '0px',
          threshold: 0.1,
        }
      )

      this.observer.observe(this.sentinel)
    })
  }

  ngOnDestroy() {
    this.observer?.disconnect()
    this.sentinel?.remove()
  }
}
